import { useEffect } from 'react'
import { Card, Typography } from 'antd'

const SupportPage = () => {
  document?.getElementById('container')?.scroll({ top: 0, behavior: 'smooth' })

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://forms.yandex.ru/_static/embed.js'
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <Card
      // loading={!availableSurveys && !isWrongSurvey}
      styles={{
        body: { fontWeight: 700, padding: '0 16px 16px 16px' },
        title: {
          fontSize: '18px',
          fontWeight: 700,
          whiteSpace: 'normal',
          padding: '16px 0 24px 0',
          marginLeft: '-8px'
        },
        header: { borderBottom: 'unset' }
      }}
      style={{ borderRadius: '16px', background: '#F9F9F9' }}
      title={<Typography.Text style={{ fontSize: 18, fontWeight: 700 }}>Обратная связь</Typography.Text>}
    >
      <iframe
        title='Обратная связь'
        src='https://forms.yandex.ru/cloud/66545dfe5d2a060b2d0acbae/?iframe=1'
        frameBorder='0'
        name='ya-form-66545dfe5d2a060b2d0acbae'
        width='100%'
        height='100%'
        style={{ minHeight: 500 }}
      />
    </Card>
  )
}

export default SupportPage
